import { useEffect, useState } from 'react';
import Button from '../../Simple/Button';
import Input from '../../Simple/Input';
import Select from '../../Simple/Select';

export default function MultiInput(props) {
    const [count, setCount] = useState(0);
    const [enteredCount, setEnteredCount] = useState(0);

    const childrenProps = [
        ...(Array.isArray(props.children) ? props.children.map(c => c.props) : [props.children.props])
    ];

    useEffect(() => {
        setCount(props.collection.values.length);
        setEnteredCount(props.collection.values.length);
    }, [props.collection.values]);

    const reachedMax = (value) => {
        return props.max !== undefined && props.max !== null && value >= props.max;
    }

    const handleOnAdd = () => {
        if (!reachedMax(count)) {
            props.collection.add();
        }
    };

    const handleOnChange = (name, index, value) => {
        props.collection.change(index, name, value);
    };

    const handleOnRemove = () => {
        props.collection.remove(props.collection.values.length - 1);
    };

    const handleOnEnteredCountChange = (value) => {
        if (value > count) {
            if (reachedMax(value)) {
                value = props.max;
            }
            props.collection.bulkAdd(value - count);
        } else if (value < count) {
            props.collection.bulkRemove(count - value);
        }

        setEnteredCount(value);
    };

    const getInput = (childProps, value, index) => {
        switch (childProps.type) {
            case 'text':
                return (<Input label={`${childProps.label} ${index + 1}`} placeholder={childProps.placeholder} id={`${props.id}-${childProps.name}-${index}`} labelClassName="fw-bold" onChange={(v) => handleOnChange(childProps.name, index, v)} value={value === undefined || value === null ? '' : value} maxLength={childProps.maxLength} />);
            case 'select':
                return (<Select label={`${childProps.label} ${index + 1}`} id={`${props.id}-${childProps.name}-${index}`} labelClassName="fw-bold" onChange={(v) => handleOnChange(childProps.name, index, v)} value={value === undefined || value === null ? '' : value}>
                    {childProps.options.map((o, index) => {
                        return <option key={`${o.value}-${index}`} value={o.value}>{o.text}</option>
                    })}
                </Select>);
        }

        return null;
    };

    return (
        <>
            <h4>{props.label}</h4>
            {props.note && <div className="fst-italic fw-bold">{props.note || ' '}</div>}
            {props.collection.values.length === 0 && <div className="fs-6">Select ADD to begin adding {props.label}</div>}
            <div className="row">
                <div className="col-auto">
                    <Input type="number" label={props.lineCountLabel} labelClassName="fw-bold" id={`${props.id}-total-values`} value={enteredCount} onChange={handleOnEnteredCountChange} />
                </div>
            </div>
            {props.collection.values.map((v, index) => {
                return (
                    <div className="row my-2 g-0" key={index}>
                        {childrenProps.map(cp => {
                            return (
                                <div className="col me-2" key={`${cp.name}-${index}`}>
                                    {getInput(cp, v[cp.name] === "Blank" || v[cp.name] === "One" ? v[cp.name] : v[cp.name].toUpperCase(), index)}
                                </div>
                            );

                        })}
                    </div>
                )
            })}
            <br />
            <div className="row my-1 justify-content-between g-0 me-3">
                <div className="col-auto">
                    <Button className="btn-small btn-dark my-2"
                        onClick={handleOnAdd}
                        disabled={reachedMax(count)}
                        icon={<i className="bi bi-plus ms-1"></i>}
                        text="Add"
                        id={`${props.id}-add-button`} />
                </div>
                <div className="col-auto">
                    <Button className="btn-small btn-danger my-2"
                        onClick={handleOnRemove}
                        disabled={props.collection.values.length === 0}
                        icon={<i className="bi bi-trash ms-1"></i>}
                        text="Delete"
                        id={`${props.id}-remove-button`} />
                </div>
            </div>
        </>);
}